export const InitDevTools = (): void => {
	// Intencionalmente vacío: sin herramientas de depuración en prod/stg.
};
